exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.cr-slider-wrap input.cr-slider::-webkit-slider-thumb{-webkit-appearance:none;border:none;height:16px;width:10px;border-radius:0;background:#5451de;margin-top:-6px}div.cr-slider-wrap input.cr-slider::-ms-fill-lower{background:#5451de;border-radius:10px}div.cr-slider-wrap input.cr-slider::-ms-fill-upper{background:#ccc;border-radius:10px}div.cr-slider-wrap input.cr-slider::-ms-thumb{border:none;height:16px;width:16px;border-radius:50%;background:#ddd;margin-top:1px}div.cr-slider-wrap input.cr-slider:focus::-ms-fill-lower{background:#5451de}div.cr-slider-wrap input.cr-slider:focus::-ms-fill-upper{background:#ccc}", ""]);

// exports
